module.exports = __webpack_public_path__ + "categories/icon-feature-price-0c2a43fc6406c4bbb67923acab8f3f77.svg";